import { render, staticRenderFns } from "./PointBankTelecomConfirm.vue?vue&type=template&id=7cbb7ef5"
import script from "./PointBankTelecomConfirm.vue?vue&type=script&lang=js"
export * from "./PointBankTelecomConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports